/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeLockModal_QueryVariables = {
    endDate?: string | null | undefined;
    fetchTimeRegs: boolean;
};
export type TimeLockModal_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"TimeLockModal_viewer">;
    } | null;
};
export type TimeLockModal_Query = {
    readonly response: TimeLockModal_QueryResponse;
    readonly variables: TimeLockModal_QueryVariables;
};



/*
query TimeLockModal_Query(
  $endDate: String
  $fetchTimeRegs: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "time-lock")
    ...TimeLockModal_viewer_3vmWxJ
    id
  }
}

fragment PersonDropdown_persons on PersonTypeEdge {
  node {
    id
    fullName
    firstName
    lastName
    profilePictureId
    active
    client {
      id
    }
    role {
      name
      id
    }
  }
}

fragment TimeLockModal_viewer_3vmWxJ on Viewer {
  id
  actualPersonId
  availableFeatureFlags {
    key
    id
  }
  company {
    id
    lockedPeriodYear
    lockedPeriodMonth
    lockedPeriodDay
    useTimeApproval
    modules {
      moduleType
      id
    }
    allPersons(first: 10000, excludeClientUsers: true, onlyActive: true) {
      edges {
        ...PersonDropdown_persons
        node {
          id
          fullName
          firstName
          lastName
          email
          profilePictureId
          profilePictureDefaultId
          excludeFromCompanyLockedPeriod
          submitLockedDateYear
          submitLockedDateMonth
          submitLockedDateDay
          role {
            name
            id
          }
          isViewer
          active
        }
      }
    }
    timeRegistrations(first: 10000000, endDate: $endDate, searchQuery: {filters: [{field: APPROVAL_STATUS, value: ["NOT_SUBMITTED", "SUBMITTED"]}]}, approvableTime: true, approvableTimeOff: true) @include(if: $fetchTimeRegs) {
      edges {
        node {
          id
          approvalStatus
          day
          month
          year
          person {
            id
            fullName
            profilePictureId
          }
          project {
            id
            name
            companyProjectId
            projectColor
            projectPersons(first: 100, contactsOnly: true) {
              edges {
                node {
                  person {
                    id
                    fullName
                    profilePictureId
                  }
                  id
                }
              }
            }
          }
          task {
            id
            project {
              id
              name
              companyProjectId
              projectColor
              projectPersons(first: 100, contactsOnly: true) {
                edges {
                  node {
                    person {
                      id
                      fullName
                      profilePictureId
                    }
                    id
                  }
                }
              }
            }
          }
          idleTime {
            id
            name
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDate",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchTimeRegs",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "time-lock"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"time-lock\")"
},
v3 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "approvableTime",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "approvableTimeOff",
    "value": true
  },
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000000
  },
  {
    "kind": "Literal",
    "name": "searchQuery",
    "value": {
      "filters": [
        {
          "field": "APPROVAL_STATUS",
          "value": [
            "NOT_SUBMITTED",
            "SUBMITTED"
          ]
        }
      ]
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "contactsOnly",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "ProjectPersonTypeConnection",
      "kind": "LinkedField",
      "name": "projectPersons",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPersonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectPerson",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "projectPersons(contactsOnly:true,first:100)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeLockModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "fetchTimeRegs",
                "variableName": "fetchTimeRegs"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TimeLockModal_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimeLockModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTimeApproval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "excludeClientUsers",
                    "value": true
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10000
                  },
                  {
                    "kind": "Literal",
                    "name": "onlyActive",
                    "value": true
                  }
                ],
                "concreteType": "PersonTypeConnection",
                "kind": "LinkedField",
                "name": "allPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Client",
                            "kind": "LinkedField",
                            "name": "client",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profilePictureDefaultId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "excludeFromCompanyLockedPeriod",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "submitLockedDateYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "submitLockedDateMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "submitLockedDateDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isViewer",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "allPersons(excludeClientUsers:true,first:10000,onlyActive:true)"
              },
              {
                "condition": "fetchTimeRegs",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "approvalStatus",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "day",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "month",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "year",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IdleTime",
                                "kind": "LinkedField",
                                "name": "idleTime",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "LockTimeModal_Company_timeRegistrations",
                    "kind": "LinkedHandle",
                    "name": "timeRegistrations"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TimeLockModal_Query",
    "operationKind": "query",
    "text": "query TimeLockModal_Query(\n  $endDate: String\n  $fetchTimeRegs: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"time-lock\")\n    ...TimeLockModal_viewer_3vmWxJ\n    id\n  }\n}\n\nfragment PersonDropdown_persons on PersonTypeEdge {\n  node {\n    id\n    fullName\n    firstName\n    lastName\n    profilePictureId\n    active\n    client {\n      id\n    }\n    role {\n      name\n      id\n    }\n  }\n}\n\nfragment TimeLockModal_viewer_3vmWxJ on Viewer {\n  id\n  actualPersonId\n  availableFeatureFlags {\n    key\n    id\n  }\n  company {\n    id\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    useTimeApproval\n    modules {\n      moduleType\n      id\n    }\n    allPersons(first: 10000, excludeClientUsers: true, onlyActive: true) {\n      edges {\n        ...PersonDropdown_persons\n        node {\n          id\n          fullName\n          firstName\n          lastName\n          email\n          profilePictureId\n          profilePictureDefaultId\n          excludeFromCompanyLockedPeriod\n          submitLockedDateYear\n          submitLockedDateMonth\n          submitLockedDateDay\n          role {\n            name\n            id\n          }\n          isViewer\n          active\n        }\n      }\n    }\n    timeRegistrations(first: 10000000, endDate: $endDate, searchQuery: {filters: [{field: APPROVAL_STATUS, value: [\"NOT_SUBMITTED\", \"SUBMITTED\"]}]}, approvableTime: true, approvableTimeOff: true) @include(if: $fetchTimeRegs) {\n      edges {\n        node {\n          id\n          approvalStatus\n          day\n          month\n          year\n          person {\n            id\n            fullName\n            profilePictureId\n          }\n          project {\n            id\n            name\n            companyProjectId\n            projectColor\n            projectPersons(first: 100, contactsOnly: true) {\n              edges {\n                node {\n                  person {\n                    id\n                    fullName\n                    profilePictureId\n                  }\n                  id\n                }\n              }\n            }\n          }\n          task {\n            id\n            project {\n              id\n              name\n              companyProjectId\n              projectColor\n              projectPersons(first: 100, contactsOnly: true) {\n                edges {\n                  node {\n                    person {\n                      id\n                      fullName\n                      profilePictureId\n                    }\n                    id\n                  }\n                }\n              }\n            }\n          }\n          idleTime {\n            id\n            name\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '186cb3f51fcc3ce6ba5fc8e2ba828a9f';
export default node;
